// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_in-0";